import { updateProjectIssueCategoriesDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateProjectIssueCategoriesCallable = getCallable(
  updateProjectIssueCategoriesDefinition,
);
